import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";
import task05 from "./layouts/task-05/task";
import task06 from "./layouts/task-06/task";
import task07 from "./layouts/task-07/task";

const lesson: Lesson = {
  id: "35778744-078d-4258-907b-73c3fe2922f5",
  publicId: "7",
  name: "Loudness",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01, task02, task03, task04, task05, task06, task07],
};

export default lesson;
